// Local Storage
import ls from "local-storage";

export function getAuthData() {
  return ls.get('authData');
}

export function getCurrentUser() {
  return ls.get('authData');
}

export function getCurrentUserId() {
  const authData = getAuthData();
  if (authData != null && typeof authData !== "undefined") {
    return authData.email;
  }
  return null;
}

export function getCurrentOrganizationId() {
  return ls.get('organizationid');
}
